import { Record, RecordOf } from 'immutable';

import { StandardAction } from '../types';
import FileAction from './file.actions';
import { IFileState } from './types';

const initData: IFileState = {
  isUploading: false,
  error: '',
};

const initialState = Record(initData)(initData);

export default class FileReducer {
  static getReducer(state: RecordOf<IFileState> = initialState, action: StandardAction): RecordOf<IFileState> {
    switch (action.type) {
      // Upload File
      case FileAction.TYPES.UPLOAD_FILE.START:
      case FileAction.TYPES.UPLOAD_FILE.SUCCESS:
      case FileAction.TYPES.UPLOAD_FILE.FAILURE:
        return FileReducer.handleUploadFile(state, action);

      default:
        return state;
    }
  }

  // handle upload file
  static handleUploadFile = (state: RecordOf<IFileState>, action: StandardAction<IFileState>): RecordOf<IFileState> => {
    switch (action.type) {
      case FileAction.TYPES.UPLOAD_FILE.START:
        return {
          ...state,
          isUploading: true,
          error: '',
        };

      case FileAction.TYPES.UPLOAD_FILE.SUCCESS:
        return {
          ...state,
          isUploading: false,
          error: '',
        };

      case FileAction.TYPES.UPLOAD_FILE.FAILURE:
        return {
          ...state,
          isUploading: false,
          error: action.error || '',
        };

      default:
        return state;
    }
  };
}
